const tokenKey = 'suxinhui_h5_token'
const authSwitchKey = 'suxinhui_authswitch'
const appTokenKey = 'suxinhui_h5_app_token'
const refreshTokenKey = 'suxinhui_h5_refresh_token'

// 存储、取、删除token
export function getToken() {
  return sessionStorage.getItem(tokenKey)
}

export function setToken(token) {
  sessionStorage.setItem(tokenKey, token)
}

export function removeToken() {
  sessionStorage.removeItem(tokenKey)
}

// 存储、取、删除selfAppToken
export function getAppToken() {
  return sessionStorage.getItem(appTokenKey)
}

export function setAppToken(selfAppToken) {
  sessionStorage.setItem(appTokenKey, selfAppToken)
}

export function removeAppToken() {
  sessionStorage.removeItem(appTokenKey)
}

// 存储、取、删除refreshToken
export function getRefreshToken() {
  return sessionStorage.getItem(refreshTokenKey)
}

export function setRefreshToken(refreshToken) {
  sessionStorage.setItem(refreshTokenKey, refreshToken)
}

export function removeRefreshToken() {
  sessionStorage.removeItem(refreshTokenKey)
}

/**
 * 证照保护缓存操作
 */
export function getAuthSwitch() {
  return sessionStorage.getItem(authSwitchKey)
}
export function setAuthSwitch(val) {
  return sessionStorage.setItem(authSwitchKey, val)
}
export function removeAuthSwitch() {
  sessionStorage.removeItem(authSwitchKey)
}
